import { render, staticRenderFns } from "./CornerRedYellow.vue?vue&type=template&id=084d7042&scoped=true"
import script from "./CornerRedYellow.vue?vue&type=script&lang=ts"
export * from "./CornerRedYellow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084d7042",
  null
  
)

export default component.exports